// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from '../../gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type TransferResultFragment = {
  readonly __typename: 'TransferBetweenSavingsAccountReply';
  readonly operationalAccount: {
    readonly __typename: 'Account';
    readonly accountNumber: string;
    readonly balanceNok: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
    readonly accruedInterest: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
  };
  readonly savingsAccount: {
    readonly __typename: 'Account';
    readonly accountNumber: string;
    readonly balanceNok: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
    readonly accruedInterest: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
  };
};

export type TransferToSavingsAccountMutationVariables = Types.Exact<{
  amount: Types.Scalars['Amount'];
}>;

export type TransferToSavingsAccountMutation = {
  readonly __typename: 'Mutation';
  readonly transferToSavingsAccount: {
    readonly __typename: 'TransferBetweenSavingsAccountReply';
    readonly operationalAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly accruedInterest: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    };
    readonly savingsAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly accruedInterest: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    };
  };
};

export type TransferFromSavingsAccountMutationVariables = Types.Exact<{
  amount: Types.Scalars['Amount'];
}>;

export type TransferFromSavingsAccountMutation = {
  readonly __typename: 'Mutation';
  readonly transferFromSavingsAccount: {
    readonly __typename: 'TransferBetweenSavingsAccountReply';
    readonly operationalAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly accruedInterest: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    };
    readonly savingsAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly accruedInterest: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    };
  };
};

export type EarmarksFragment = {
  readonly __typename: 'Earmark';
  readonly fid: string;
  readonly name: string;
  readonly icon: string;
  readonly amount: {
    readonly __typename: 'AmountInfo';
    readonly asNumber: number;
  };
};

export type EarmarksQueryVariables = Types.Exact<{ [key: string]: never }>;

export type EarmarksQuery = {
  readonly __typename: 'Query';
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly earmarks: ReadonlyArray<{
      readonly __typename: 'Earmark';
      readonly fid: string;
      readonly name: string;
      readonly icon: string;
      readonly amount: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      };
    }>;
    readonly operationalAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    } | null;
    readonly savingsAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly accruedInterest: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    } | null;
  };
};

export type EarmarkTransferResultFragment = {
  readonly __typename: 'TransferBetweenOperationalAndEarmarkReply';
  readonly operationalAccount: {
    readonly __typename: 'Account';
    readonly accountNumber: string;
    readonly balanceNok: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
  };
  readonly savingsAccount: {
    readonly __typename: 'Account';
    readonly accountNumber: string;
    readonly balanceNok: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
    readonly accruedInterest: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
  };
  readonly earmarks: ReadonlyArray<{
    readonly __typename: 'Earmark';
    readonly fid: string;
    readonly name: string;
    readonly icon: string;
    readonly amount: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    };
  }>;
};

export type TransferFromOperationalToEarmarkMutationVariables = Types.Exact<{
  earmarkFid?: Types.InputMaybe<Types.Scalars['UUID']>;
  amount: Types.Scalars['Amount'];
}>;

export type TransferFromOperationalToEarmarkMutation = {
  readonly __typename: 'Mutation';
  readonly transferFromOperationalToEarmark: {
    readonly __typename: 'TransferBetweenOperationalAndEarmarkReply';
    readonly operationalAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    };
    readonly savingsAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly accruedInterest: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    };
    readonly earmarks: ReadonlyArray<{
      readonly __typename: 'Earmark';
      readonly fid: string;
      readonly name: string;
      readonly icon: string;
      readonly amount: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      };
    }>;
  };
};

export type TransferFromEarmarkToOperationalMutationVariables = Types.Exact<{
  earmarkFid?: Types.InputMaybe<Types.Scalars['UUID']>;
  amount: Types.Scalars['Amount'];
}>;

export type TransferFromEarmarkToOperationalMutation = {
  readonly __typename: 'Mutation';
  readonly transferFromEarmarkToOperational: {
    readonly __typename: 'TransferBetweenOperationalAndEarmarkReply';
    readonly operationalAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    };
    readonly savingsAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly accruedInterest: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    };
    readonly earmarks: ReadonlyArray<{
      readonly __typename: 'Earmark';
      readonly fid: string;
      readonly name: string;
      readonly icon: string;
      readonly amount: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      };
    }>;
  };
};

export const TransferResultFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'transferResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TransferBetweenSavingsAccountReply' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operationalAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'balanceNok' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asNumber' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accruedInterest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asNumber' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'savingsAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'balanceNok' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asNumber' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accruedInterest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asNumber' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TransferResultFragment, unknown>;
export const EarmarksFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'earmarks' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Earmark' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'asNumber' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EarmarksFragment, unknown>;
export const EarmarkTransferResultFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'earmarkTransferResult' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'TransferBetweenOperationalAndEarmarkReply',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operationalAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'balanceNok' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asNumber' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'savingsAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'balanceNok' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asNumber' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accruedInterest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asNumber' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earmarks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'earmarks' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EarmarkTransferResultFragment, unknown>;
export const TransferToSavingsAccountDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TransferToSavingsAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'amount' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Amount' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transferToSavingsAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'amount' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'transferResult' },
                },
              ],
            },
          },
        ],
      },
    },
    ...TransferResultFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  TransferToSavingsAccountMutation,
  TransferToSavingsAccountMutationVariables
>;
export const TransferFromSavingsAccountDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TransferFromSavingsAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'amount' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Amount' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transferFromSavingsAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'amount' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'transferResult' },
                },
              ],
            },
          },
        ],
      },
    },
    ...TransferResultFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  TransferFromSavingsAccountMutation,
  TransferFromSavingsAccountMutationVariables
>;
export const EarmarksDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Earmarks' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'earmarks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'earmarks' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operationalAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'balanceNok' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'asNumber' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'savingsAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'balanceNok' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'asNumber' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accruedInterest' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'asNumber' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...EarmarksFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<EarmarksQuery, EarmarksQueryVariables>;
export const TransferFromOperationalToEarmarkDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TransferFromOperationalToEarmark' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'earmarkFid' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'amount' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Amount' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transferFromOperationalToEarmark' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'earmarkFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'earmarkFid' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'amount' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'earmarkTransferResult' },
                },
              ],
            },
          },
        ],
      },
    },
    ...EarmarkTransferResultFragmentDoc.definitions,
    ...EarmarksFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  TransferFromOperationalToEarmarkMutation,
  TransferFromOperationalToEarmarkMutationVariables
>;
export const TransferFromEarmarkToOperationalDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TransferFromEarmarkToOperational' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'earmarkFid' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'amount' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Amount' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transferFromEarmarkToOperational' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'earmarkFid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'earmarkFid' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'amount' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'earmarkTransferResult' },
                },
              ],
            },
          },
        ],
      },
    },
    ...EarmarkTransferResultFragmentDoc.definitions,
    ...EarmarksFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  TransferFromEarmarkToOperationalMutation,
  TransferFromEarmarkToOperationalMutationVariables
>;
